import * as React from 'react'
import Card from 'material-ui/Card/Card'
import {url} from '../../../App/AuthenticatedRoute'

export function Step5View({orderNumber}: {orderNumber: string}) {
    return (
        <div style={{display: 'flex', justifyContent: 'center'}}>
            <Card
                className="card"
                style={{maxWidth: '1536px', flex: '1'}}
            >
                <div className="card__row">
                    <div className="card__column">
                        <h2 className="card__header">Bestellung erfolgreich
                            angelegt</h2>
                        <div className="card__content">
                            <p>
                                Ihre Bestellung wurde mit der Nummer&#x20;
                                <a href={url({type: 'OrderDetails', orderNumber})}>
                                    {orderNumber}
                                </a>&#x20;
                                angelegt.
                            </p>
                        </div>
                    </div>
                </div>
            </Card>
        </div>)
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/OrderCreate/Step5/Step5View.tsx